


























































import Vue, { PropType } from "vue";
import { mapGetters } from "vuex";
import { focus } from "vue-focus";
import FormatHeader1Icon from "vue-material-design-icons/FormatHeader1.vue";
import FormatHeader2Icon from "vue-material-design-icons/FormatHeader2.vue";
import FormatBoldIcon from "vue-material-design-icons/FormatBold.vue";
import FormatItalicIcon from "vue-material-design-icons/FormatItalic.vue";
import FormatUnderlineIcon from "vue-material-design-icons/FormatUnderline.vue";
import MatrixIcon from "vue-material-design-icons/Matrix.vue";
import TextShow from "../show/TextShow.vue";
import Markdown from "@/dex-shared/helpers/markdown";
import TextModel from "@/dex-shared/models/TextModel";

export default Vue.extend({
  components: {
    TextShow,
    FormatHeader1Icon,
    FormatHeader2Icon,
    FormatBoldIcon,
    FormatItalicIcon,
    FormatUnderlineIcon,
    MatrixIcon
  },
  directives: { focus: focus },
  props: {
    textId: {
      type: Number,
      required: true
    },
    trustedContent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      focused: false
    };
  },
  computed: {
    ...mapGetters({
      textById: "textById"
    }),
    text() {
      return this.textById(this.textId)
    },
    textComponent: function() {
      return { content: this.text.body };
    }
  },
  methods: {
    updateTextBody: function(body: string) {
      this.$store.commit(
        "UPDATE_ENTITY",  {
          entity: "texts",
          data: {
            ...this.text.raw(),
            body//: body.split('\\n').join('\n')
          }
        }
      );
    },
    toggleMarkdown(tag: string) {
      const tagProperties = Markdown.tags[tag];
      const textArea = this.$refs.textarea;
      const { selectionStart, selectionEnd } = textArea;
      const lines = this.text.body.split("\n");
      const currentLineIndex =
        this.text.body.slice(0, selectionStart).split("\n").length - 1;
      const currentLine = lines[currentLineIndex];

      if (!tagProperties.end) {
        const currentLineStart = currentLine.slice(
          0,
          tagProperties.start.length + 1
        );
        const isAlreadyMarked = currentLineStart === `${tagProperties.start} `;

        lines[currentLineIndex] = isAlreadyMarked
          ? currentLine.slice(tagProperties.start.length + 1)
          : `${tagProperties.start} ${currentLine}`;

        this.updateTextBody(lines.join("\n"));
        textArea.selectionStart = currentLine.length - 1;
        textArea.selectionEnd = currentLine.length - 1;
        textArea.focus();
      } else {
        const selectedInput = this.text.body.slice(selectionStart, selectionEnd);
        const beforeSelectedInput = this.text.body.slice(
          selectionStart - tagProperties.start.length,
          selectionStart
        );
        const isAlreadyMarked = beforeSelectedInput === tagProperties.start;

        const removingExistingMarkup =
          this.text.body.slice(0, selectionStart - tagProperties.start.length) +
          this.text.body.slice(selectionStart, selectionEnd) +
          this.text.body.slice(selectionEnd + tagProperties.end.length);

        const addingNewMarkup =
          this.text.body.slice(0, selectionStart) +
          `${tagProperties.start}${this.text.body.slice(
            selectionStart,
            selectionEnd
          )}${tagProperties.end}` +
          this.text.body.slice(selectionEnd);

        this.updateTextBody(
          isAlreadyMarked ? removingExistingMarkup : addingNewMarkup
        );
        const cursorDisplacement = isAlreadyMarked
          ? -tagProperties.start.length
          : tagProperties.start.length;

        textArea.focus();
        setTimeout(
          // Necessary because of a bug with setSelectionRange being called after a focus on same loop
          () =>
            textArea.setSelectionRange(
              selectionStart + cursorDisplacement,
              selectionEnd + cursorDisplacement
            ),
          0
        );
      }
    }
  }
});
